/*
 *
 * SettingsLanguagePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 23-Apr-2025
*/

import SettingsLanguagePopup from './SettingsLanguagePopupContainer'

export default SettingsLanguagePopup
